import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-file-export-renderer',
    templateUrl: './file-export-renderer.component.html',
    styleUrls: ['./file-export-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class FileExportRendererComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.info('something')
  }

}
